import { initializeApp, getApps } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { GoogleAuthProvider, getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { setFunctionHost } from '@ekhodealer/ekho-common/server';
import { ENV } from './common/data/constants';

// ----- get necessary auth and db objects ----- //
const oemKeyMatch = (appInstance) => appInstance.name === process.env.REACT_APP_OEM_KEY;
const fbApps = getApps();

// see if the specific app for that oem has already be instantiated - if so, use it - otherwise create it
const appIndex = fbApps.findIndex(oemKeyMatch);
const app =
	appIndex === -1
		? initializeApp(
				JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG),
				process.env.REACT_APP_OEM_KEY,
		  )
		: fbApps[appIndex];

// Set up AppCheck for production environment
if (process.env.REACT_APP_CURR_ENV !== ENV.PRODUCTION) {
	// eslint-disable-next-line no-restricted-globals
	self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_VERIFICATION_DEBUG_TOKEN;
}
const appCheck = initializeAppCheck(app, {
	provider: new ReCaptchaV3Provider(process.env.REACT_APP_SITE_KEY),
	isTokenAutoRefreshEnabled: true,
});

const db =
	process.env.REACT_APP_CURR_ENV === ENV.LOCAL
		? getFirestore(app, process.env.REACT_APP_ENG)
		: getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

const googleProvider = new GoogleAuthProvider();

const FUNCTION_HOST = setFunctionHost(process.env.REACT_APP_CURR_ENV);

export { auth, db, storage, appCheck, googleProvider, FUNCTION_HOST, app };
